import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import * as React from "react";
import {useEffect, useState} from "react";
import {RootState, useAppDispatch, useAppSelector} from "../../../state/state.tsx";
import {SubscriptionDocWithId} from "../../Subscriptions/types/SubscriptionType.ts";
import {Box, Checkbox, CircularProgress, IconButton, InputAdornment, MenuItem, TextField} from "@mui/material";
import {LiveSubscriptionType} from "../../Subscriptions/types/LiveSubscriptionTypes.ts";
import {closeModal} from "../../../state/ModalSlice/ModalSlice.ts";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import {setDataForFetchExistingSubsctibersModal} from "../../../state/ArbitrarySlice/ArbitratySlice.ts";

export default function FetchExistingSubscriptionModal() {
    const Dispatch = useAppDispatch();

    //Form States
    const [selectedSubscription, setSelectedSubscription] = useState<number>(-1);
    const [searchableTerm, setSearchableTerm] = useState<string>("");
    const [selectedSubscriberArray, setSelectedSubscriberArray] = useState<LiveSubscriptionType[]>([]);

    // PreFetch Already SELECTED CUSTOMERS
    const preSelectedCustomers = useAppSelector((state: RootState) => state.ArbitrarySlice.ForFetchExistingSubscribersModal.data)
    useEffect(() => {
        if (preSelectedCustomers) {
            setSelectedSubscriberArray([...preSelectedCustomers]);
        }

    }, [preSelectedCustomers]);

    //Form Options
    const SubscriptionsList: SubscriptionDocWithId[] = useAppSelector((state: RootState) => state.subscriptionTableSlice.data)

    // Live subscription Documents Array

    const LiveSubscriptionDocumentArray: LiveSubscriptionType[] = useAppSelector((state: RootState) => state.LiveSubscriptionSlice.data)

    const FilteredLiveSubscriptionswithSubscription: LiveSubscriptionType[] = LiveSubscriptionDocumentArray.filter((docs) => {
        if (selectedSubscription === -1) {
            return true
        } else {
            return docs.subscriptionPlanRefId === SubscriptionsList[selectedSubscription].id
        }

    })

    const FilteredLiveSubscriptions: LiveSubscriptionType[] = FilteredLiveSubscriptionswithSubscription.filter(item => item.name.toLowerCase().includes(searchableTerm.toLowerCase()));


    // handle change states

    function handleChangeSelectedSubscription(e: React.ChangeEvent<HTMLInputElement>) {
        setSelectedSubscription(Number(e.target.value))
    }

    function onChangeCheckboxClicked(e: React.ChangeEvent<HTMLInputElement>) {
        const docId = e.target.id;
        const doc = FilteredLiveSubscriptions.find(d => d.id === docId); // Find the document in the docs array

        if (!doc) return; // Exit if the document is not found

        const index = selectedSubscriberArray.findIndex(d => d.id === docId);

        if (e.target.checked) {
            if (index === -1) {
                setSelectedSubscriberArray([...selectedSubscriberArray, doc]);
            }
        } else {
            if (index !== -1) {
                setSelectedSubscriberArray((prev) => {
                    const newList = [...prev];
                    newList.splice(index, 1);
                    return newList;
                });
            }
        }
    }


    //Modal Handling Functions
    const open = useAppSelector((state: RootState) => state.ModalSlice.FetchExistingSubscribersModalOpen)

    function handleClose() {
        Dispatch(closeModal("FetchExistingSubscribersModalOpen"))
    }

    // onSubmit

    const isLoading: boolean = useAppSelector((state: RootState) => state.ModalSlice.isLoading)

    async function onSubmit() {

        Dispatch(setDataForFetchExistingSubsctibersModal(selectedSubscriberArray))
        handleClose()
    }

    function isChecked(id: string) {
        return selectedSubscriberArray.some(doc => doc.id === id);
    }

    return (<div>
        <Dialog

            maxWidth="md"
            // fullWidth={true}
            open={open}
            sx={{
                padding: 0, '& .MuiPaper-root': {
                    borderRadius: '10px',
                },
            }}
        >

            <DialogContent sx={{paddingY: "50px", paddingX: "60px"}} className={"bg-white"}>
                <div className={"header "}>
                    <p className={"text-cf_heading font-[600] "}>Fetch Existing Customers</p>
                    <p className={"text-cf_small font-[400] "}>Manually Select and Add Customers to Send Campaign
                        Messages</p>
                </div>

                <div>
                    <p className={"mt-2 mb-4 font-semibold text-lg text-cc_brand"}>Selected Students
                        - {selectedSubscriberArray.length}</p>
                </div>
                <Box
                    component={"div"}
                    sx={{}}
                >
                    <div className={"p-2 rounded-lg border-cc_modal-grey-border border-[1px] w-[550px]"}>

                        <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                            <CloseIcon fontSize={"medium"}/>
                        </IconButton></div>

                        <div className={""}>
                            <div className={"flex flex-col gap-2.5"}>
                                <TextField
                                    size={"small"}
                                    id="SelectSubscription"
                                    select
                                    fullWidth={true}
                                    label="Subscription Plan"
                                    value={selectedSubscription}
                                    onChange={handleChangeSelectedSubscription}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'grey', borderRadius: '10px'// Default border color
                                            }, '&:hover fieldset': {
                                                borderColor: 'grey', // Border color on hover
                                            }, '&.Mui-focused fieldset': {
                                                borderColor: 'skyblue', // Border color when focused
                                            }, '& .MuiInputBase-input': {
                                                fontSize: '14px', // Setting font size
                                            },
                                        }, fontWeight: 400, fontSize: "1px",
                                    }}
                                >
                                    <MenuItem key="0" value={-1}>
                                        All Subscription
                                    </MenuItem>
                                    {SubscriptionsList.map((option, index) => (
                                        <MenuItem key={index} value={index}>
                                            {option.Name} - ₹{option.Price}
                                        </MenuItem>))}

                                </TextField>
                                <TextField
                                    size={"small"}
                                    id="SearchableTerm"
                                    fullWidth={true}
                                    label="Search Student"
                                    value={searchableTerm}
                                    onChange={(e) => {
                                        setSearchableTerm(e.target.value)
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'grey', borderRadius: '10px'// Default border color
                                            }, '&:hover fieldset': {
                                                borderColor: 'grey', // Border color on hover
                                            }, '&.Mui-focused fieldset': {
                                                borderColor: 'skyblue', // Border color when focused
                                            }, '& .MuiInputBase-input': {
                                                fontSize: '14px', // Setting font size
                                            },
                                        }, fontWeight: 400, fontSize: "1px",
                                    }}
                                    InputProps={{
                                        startAdornment: (<InputAdornment position="start">
                                            <SearchIcon/>
                                        </InputAdornment>),
                                    }}
                                >
                                </TextField>

                            </div>
                            <div className={"h-0 border-cc_modal-grey-border mt-2 border-[1px] w-full"}></div>
                            {FilteredLiveSubscriptions.length > 0 ? <div>
                                {FilteredLiveSubscriptions.map((docs: LiveSubscriptionType) => {
                                    return (<div key={docs.id} className={"px-4 py-3 w-full flex relative"}>
                                        <div
                                            className={"Avatar bg-cc_brand rounded-full size-10  flex justify-center items-center text-white font-thin text-cf_subHeading"}>
                                            {docs.name[0]}
                                        </div>
                                        <div title={docs.name}
                                             className="flex ml-2 flex-col justify-between w-[20%] cursor-pointer">
                                            <p className="font-normal overflow-hidden text-ellipsis whitespace-nowrap">{docs.name}</p>
                                            <p className={`text-[14px] ${docs.status === "Active" ? "text-cc_success" : "text-cc_error"}`}>{docs.status}</p>
                                        </div>
                                        <div
                                            className={`absolute right-3 top-4 flex justify-center h-4 cursor-pointer`}>

                                            <Checkbox id={docs.id} checked={isChecked(docs.id)}
                                                      className={``}
                                                      onChange={onChangeCheckboxClicked}
                                            />
                                        </div>

                                    </div>)
                                })}

                            </div> : <div className={"flex  flex-col items-center p-4 justify-center"}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                     strokeLinejoin="round" className="feather feather-info">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                </svg>

                                No Users in Subscription!
                            </div>}

                        </div>

                    </div>
                </Box>

                <div>

                </div>
                <div className={"flex gap-2 pt-2"}>
                    <button onClick={handleClose} disabled={isLoading}
                            className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>Cancel
                    </button>
                    <button
                        onClick={onSubmit} disabled={isLoading}
                        className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>

                        {!isLoading && "Add Customers"}

                        {isLoading && <CircularProgress sx={{color: "white"}} size={20}/>}
                        <p className={"ml-2"}>{isLoading && "Loading"}</p>
                    </button>

                </div>
            </DialogContent>
        </Dialog>
    </div>)
}